import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestRevisionCurrentGet = {
    path: "/revision/current",
    method: RouteHttpVerb.GET
};
